export default {
  Page: require('./page').default,
  MobileRequest: require('./mobile_request').default,
};
